import { combineReducers } from 'redux'

import newAccount from 'apps/addNewAccount/reducers'
import { adsReducer as ads } from 'apps/ads/reducers'
import { agencyReducer as agency } from 'apps/agency/model/reducer'
import { AiAgentGeneratorReducer } from 'apps/aiAgentGenerator/store'
import { AiAgentPlaygroundReducer } from 'apps/aiAgentPlayground/store'
import { AiAssistantReducer } from 'apps/aiAssistant/store'
import { aiAutomationReducer } from 'apps/aiAutomation/store'
import { AiCommunicationsReducer } from 'apps/aiCommunications/store'
import { AiIntentsReducer } from 'apps/aiIntents/store'
import { AiStepStatsReducer } from 'apps/aiStepStats/store'
import { liveChatStatisticsSlice } from 'apps/analytics/redux/liveChatStatisticsSlice'
import applications from 'apps/applications/reducers'
import { chatReducer as chat } from 'apps/chat/reducers'
import { contentManagementSystemReducer } from 'apps/cms/store'
import { collectOptInsReducer as collectOptIns } from 'apps/collectOptIns/reducers'
import { metricsReducer as metricsDashboard } from 'apps/dashboard/components/Metrics/reducers'
import { dashboardReducer as dashboard } from 'apps/dashboard/reducers'
import { defaultReplyReducer as defaultReply } from 'apps/defaultReply/store'
import { reducer as email } from 'apps/email/reducers/emailSlice'
import { externalTriggersReducer as externalTriggers } from 'apps/externalTriggers/reducers'
import { FlowPickerReducer } from 'apps/flowPicker/store'
import { flowPlayerReducer as flowPlayer } from 'apps/flowPlayer/reducers/flowPlayer'
import { followReplyReducer } from 'apps/followReply/store'
import {
  widgetCheckerReducer as widgetChecker,
  widgetsReducer as widgets,
} from 'apps/growthTools/reducers'
import { iceBreakersReducer as iceBreakers } from 'apps/iceBreakers/reducers/iceBreakersReducer'
import { instagramReducer } from 'apps/instagram/store'
import { keywordsReducer as keywords } from 'apps/keywords/keywordsSlice'
import { menuReducer as menu } from 'apps/menu/reducers/menuReducer'
import { messengerReducer as messenger } from 'apps/messenger/redux/messengerReducer'
import { AnalyticsReducer } from 'apps/performanceAnalytics/store'
import broadcastModals from 'apps/posting/pages/BroadcastBuilder/components/SimplifiedBroadCast/slices/modalsSlice'
import { postsReducer as posts } from 'apps/posting/reducers'
import broadcastInstagramWizard from 'apps/posting/slices/BroadcastInstagramWizardSlice'
import broadcastMessengerWizard from 'apps/posting/slices/BroadcastMessengerWizardSlice'
import { profileReducer as profile } from 'apps/profile/reducers'
import newQuestionnaire from 'apps/questionnaire/reducers/newQuestionnaireSlice'
import sms from 'apps/sms/reducers/sms'
import { sponsoredMessagesReducer as sm } from 'apps/sponsoredMessages/reducers'
import { storyMentionReplyReducer as storyMention } from 'apps/storyMentionReply/reducers'
import { supportReducer as support } from 'apps/support/reducers'
import { systemKeywordsReducer as systemKeywords } from 'apps/systemKeywords/systemKeywordsReducer'
import { templatesReducer as templates } from 'apps/templates/reducers'
import { tiktokFollowWelcomeReducer as tiktokFollowWelcome } from 'apps/tiktokFollowWelcome/store'
import { tiktokFollowWelcomeSetupModalSlice } from 'apps/tiktokFollowWelcome/store/setupModal'
import { reducer as triggerPicker } from 'apps/triggerPicker/redux/triggerPicker'
import { triggerRulesReducer as triggerRules } from 'apps/triggerRules/slices/triggerRuleListSlice'
import { welcomeMessageReducer as welcomeMessage } from 'apps/welcomeMessage/reducers/welcomeMessageReducer'
import { whatsappReducer as whatsApp } from 'apps/whatsApp/redux/whatsAppReducer'
import {
  devToolsReducer as devTools,
  integrationsReducer as integrations,
  integromatWebhooksReducer as integromatWebhooks,
} from 'common/actions/reducers'
import { answersReducer } from 'common/answers/model/answersSlice'
import { audienceSlice } from 'common/audience'
import { FlowForSimulatorReducer } from 'common/automationStarters/store/flowForSimulatorSlice'
import { billingReducer as billing } from 'common/billing/reducers'
import { buildersReducer as builders, managerReducer as manager } from 'common/builder/reducers'
import { cmsReducer as cms } from 'common/cms/model/slice'
import bulkActions from 'common/core/bulkActions'
import { appReducer as app, uiReducer as ui } from 'common/core/reducers'
import { refreshPermissions } from 'common/core/reducers/refreshPermissions'
import { customEventsReducer as customEvents } from 'common/events/model/slice'
import { availableFieldsReducer as availableFields } from 'common/fields/linking/accountAvailableFields'
import {
  globalFieldFoldersReducer as globalFieldFolders,
  userFieldFoldersReducer as userFieldFolders,
  userFieldsReducer as userFields,
} from 'common/fields/reducers'
import { GlobalFieldsReducer } from 'common/fields/store/globalFields'
import { filterReducer as filter, segmentsSlice } from 'common/filter/reducers'
import flow from 'common/flow/reducers/flow'
import { groupsReducer as groups } from 'common/groups/reducers/groups'
import { mappingReducer as targetPage } from 'common/mapping/store'
import howToCreateTopicsModal from 'common/oneTimeNotify/components/HowToCreateTopicsModal/slices/HowToCreateTopicsModalSlice'
import instagramTopicsModal from 'common/oneTimeNotify/components/InstagramTopicsModal/slices/InstagramTopicsModal'
import { NotificationReasonReducer } from 'common/oneTimeNotify/store'
import recurringNotifications from 'common/recurringNotifications/slice'
import { sequencesReducer as sequence } from 'common/sequences/reducers'
import {
  botSettingsReducer as botSettings,
  devLogsReducer as devLogs,
  eventsReducer as events,
  ordersReducer as orders,
  policyEnforcementReducer as policyEnforcement,
  settingsReducer as settings,
  settingsAutoAssignmentReducer,
} from 'common/settings/reducers'
import smartSegments from 'common/smartSegments/reducers'
import { tagsFolderReducer as tagsFolders } from 'common/tags/reducers'
import { TagsReducer } from 'common/tags/store'
import invitation from 'common/userRoles/model/slice'
import {
  accessRequestsReducer as accessRequests,
  userRolesReducer as users,
} from 'common/userRoles/reducers'
import { zapierReducer as zaps } from 'common/zapier/redux'

export default combineReducers({
  accessRequests,
  ads,
  agency,
  aiAgentGenerator: AiAgentGeneratorReducer,
  aiAgentPlayground: AiAgentPlaygroundReducer,
  aiAssistant: AiAssistantReducer,
  aiAutomation: aiAutomationReducer,
  aiCommunications: AiCommunicationsReducer,
  aiIntents: AiIntentsReducer,
  aiStepStats: AiStepStatsReducer,
  analytics: AnalyticsReducer,
  answers: answersReducer,
  app,
  applications,
  audience: audienceSlice.reducer,
  availableFields,
  billing,
  botSettings,
  broadcastInstagramWizard,
  broadcastMessengerWizard,
  broadcastModals,
  builders,
  bulkActions,
  chat,
  cms,
  collectOptIns,
  contentManagementSystem: contentManagementSystemReducer,
  customEvents,
  dashboard,
  defaultReply,
  devLogs,
  devTools,
  policyEnforcement,
  email,
  events,
  externalTriggers,
  filter,
  flow,
  flowForSimulator: FlowForSimulatorReducer,
  flowPicker: FlowPickerReducer,
  flowPlayer,
  followReply: followReplyReducer,
  globalFieldFolders,
  globalFields: GlobalFieldsReducer,
  groups,
  howToCreateTopicsModal,
  iceBreakers,
  instagram: instagramReducer,
  instagramTopicsModal,
  integrations,
  integromatWebhooks,
  invitation,
  keywords,
  liveChatStatistics: liveChatStatisticsSlice.reducer,
  manager,
  menu,
  messenger,
  metricsDashboard,
  newAccount,
  newQuestionnaire,
  notificationReason: NotificationReasonReducer,
  orders,
  posts,
  profile,
  recurringNotifications,
  refreshPermissions,
  segments: segmentsSlice.reducer,
  sequence,
  settings,
  settingsAutoAssignment: settingsAutoAssignmentReducer,
  sm,
  smartSegments,
  sms,
  storyMention,
  support,
  systemKeywords,
  tags: TagsReducer,
  tagsFolders,
  targetPage,
  templates,
  tiktokFollowWelcome,
  tiktokFollowWelcomeSetupModal: tiktokFollowWelcomeSetupModalSlice.reducer,
  triggerPicker,
  triggerRules,
  ui,
  userFieldFolders,
  userFields,
  users,
  welcomeMessage,
  whatsApp,
  widgetChecker,
  widgets,
  zaps,
})
